module.exports = __webpack_public_path__ + "img/google.2af9b65a.svg";